export function formatParseInt(val) {
  return parseInt(val);
}